export default __webpack_public_path__ + "static/granule-0d815ebc063e0e533f8cc29b9aef65cc.png";